(() => {
  if (window.AtomicLocally) return;

  let loaded = false;
  let appliedUpc;
  let pending;
  let initialScript;
  let failedModalScript;

  const watchScript = (script, start) => new Promise((resolve, reject) => {
    const finish = (error) => {
      clearTimeout(timeout);
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
      if (error) reject(error);
      else resolve();
    };
    const onLoad = () => finish();
    const onError = () => finish(new Error('Locally could not load'));
    const timeout = setTimeout(() => finish(new Error('Locally timed out')), 20000);
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    if (start) start();
  });

  const waitForModal = () => new Promise((resolve, reject) => {
    const deadline = Date.now() + 20000;
    const script = document.getElementById('__lcly_script_inline_modal');
    let timer;
    const finish = (error) => {
      clearTimeout(timer);
      script?.removeEventListener('error', onError);
      if (error) reject(error);
      else resolve();
    };
    const onError = () => {
      failedModalScript = script;
      finish(new Error('Locally modal could not load'));
    };
    script?.addEventListener('error', onError, { once: true });
    const check = () => {
      const linkReady = typeof document.getElementById('lcly-link-0')?.onclick === 'function';
      if (!window.lcly_launch_pl_v3 || !window.lcly_query_has_product_0 ||
          (typeof window.lclyInlineModalGlobal === 'function' && linkReady)) {
        finish();
      } else if (Date.now() >= deadline) {
        finish(new Error('Locally modal timed out'));
      } else {
        timer = setTimeout(check, 100);
      }
    };
    check();
  });

  const load = () => {
    if (pending) return pending;
    pending = (async () => {
      const config = window.lcly_config_0;
      if (!config) throw new Error('Locally is not configured');
      if (!loaded) {
        const previous = document.getElementById('lcly-script-0');
        if (!previous) throw new Error('Locally script is missing');
        if (!initialScript) {
          initialScript = document.createElement('script');
          initialScript.id = previous.id;
          initialScript.async = true;
          previous.replaceWith(initialScript);
          const upc = config.upc;
          initialScript.addEventListener('load', () => {
            loaded = true;
            appliedUpc = upc;
          }, { once: true });
          initialScript.addEventListener('error', () => { initialScript = null; }, { once: true });
          await watchScript(initialScript, () => {
            initialScript.src = `https://atomic.locally.com/stores/map.js?${new URLSearchParams(config)}`;
          });
        } else {
          await watchScript(initialScript);
        }
      }
      do {
        if (appliedUpc !== config.upc) {
          const upc = config.upc;
          window.lcly_reload_0({ upc });
          await watchScript(document.getElementById('lcly-script-0'));
          appliedUpc = upc;
        }
        if (failedModalScript) {
          const retry = failedModalScript.cloneNode();
          failedModalScript.replaceWith(retry);
          failedModalScript = null;
        }
        await waitForModal();
      } while (appliedUpc !== config.upc);
    })().finally(() => { pending = null; });
    return pending;
  };

  const setUpc = (upc) => {
    if (!upc || !window.lcly_config_0) return;
    window.lcly_config_0.upc = upc;
    if (loaded) load().catch(() => {});
  };

  const opening = new WeakMap();
  const open = (drawer, showDrawer, productModal = false) => {
    if (opening.has(drawer)) {
      opening.get(drawer).cancelled = false;
      showDrawer();
      return;
    }
    const widget = drawer.querySelector('.store-locator-drawer__widget');
    const status = drawer.querySelector('[data-locally-status]');
    const retry = drawer.querySelector('[data-locally-retry]');
    const message = status.querySelector('[role="status"]');
    widget.hidden = true;
    status.hidden = false;
    retry.hidden = true;
    message.textContent = status.dataset.loading;
    showDrawer();
    drawer.setAttribute('aria-busy', 'true');
    const state = { cancelled: false };
    opening.set(drawer, state);
    const observer = new MutationObserver(() => {
      if (drawer.getAttribute('aria-hidden') === 'true') state.cancelled = true;
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    load().then(() => {
      status.hidden = true;
      widget.hidden = false;
      if (state.cancelled || drawer.getAttribute('aria-hidden') === 'true') return;
      const link = document.getElementById('lcly-link-0');
      if (productModal && window.lcly_query_has_product_0 && typeof link?.onclick === 'function') {
        drawer.close();
        // Let the drawer's scroll-lock cleanup finish before Locally owns it.
        queueMicrotask(() => document.getElementById('lcly-link-0')?.click());
      }
    }).catch(() => {
      message.textContent = status.dataset.error;
      retry.hidden = false;
      retry.onclick = () => open(drawer, showDrawer, productModal);
    }).finally(() => {
      observer.disconnect();
      drawer.removeAttribute('aria-busy');
      opening.delete(drawer);
    });
  };

  window.AtomicLocally = { load, setUpc, open };
})();
